/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingLineFeaturesQueryResponse, GetDrawingLineFeaturesPathParams, GetDrawingLineFeatures422 } from "../models/drawingClient/GetDrawingLineFeatures";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingLineFeaturesUrl(project_uuid: GetDrawingLineFeaturesPathParams["project_uuid"], file_uuid: GetDrawingLineFeaturesPathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/lines` as const }  
  return res
}

/**
 * @description Returns redirect to a download link of a GZipped GeoJSON FeatureCollection that contains all of the line features of the specified drawing file. Each feature's geometry is described as a standard GeoJSON LineString.
 * @summary Get line features for a drawing as GeoJSON feature collection
 * {@link /v1/drawings/:project_uuid/:file_uuid/lines}
 */
export async function getDrawingLineFeatures(project_uuid: GetDrawingLineFeaturesPathParams["project_uuid"], file_uuid: GetDrawingLineFeaturesPathParams["file_uuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingLineFeaturesQueryResponse, ResponseErrorConfig<GetDrawingLineFeatures422>, unknown>({ method : "GET", url : getGetDrawingLineFeaturesUrl(project_uuid, file_uuid).url.toString(), ... requestConfig })  
  return res.data
}